import script from "./TicketBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketBooking.vue?vue&type=script&setup=true&lang=js"

import "./TicketBooking.vue?vue&type=style&index=0&id=2c26cffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c26cffc"]])

export default __exports__